module.exports = __webpack_public_path__ + "img/LogoDashboard-21.a3171693.svg";